import { useZoteroSource } from "@/hooks/useZoteroSource";

import { LibraryUrlPattern } from "./LibraryUrlPattern";
import { ZoteroWebApiCard } from "./ZoteroWebApiCard";

export function ZoteroSourcePanel() {
  const { data: source } = useZoteroSource();

  return (
    <section className="space-y-3">
      <header>
        <h3 className="text-sm font-medium">PDF source — pick one</h3>
        <p className="mt-1 text-xs text-muted-foreground">
          Auto-attach PDFs from Zotero when you save them via the browser
          connector or download manually.
        </p>
      </header>
      <ZoteroWebApiCard source={source} />
      <LibraryUrlPattern />
    </section>
  );
}
